export default "__VITE_ASSET__D8F$FnlJ__"